module.exports = __webpack_public_path__ + "img/8775ba7.jpg";